import React, { useMemo, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { logInDev } from '../../../utils/log-utils';

const SafeRedirect = ({
  path, replace, onCleanUp, navigateState,
}) => {
  const { pathname, search } = useLocation();
  const state = useMemo(() => ({
    prevUrl: `${pathname}${search}`,
    ...navigateState,
  }), [path, navigateState]);

  useEffect(() => {
    if (path && path.trim()) {
      onCleanUp();
    }
  }, [path, replace]);

  if (path && path.trim()) {
    logInDev(`App redirecting to ${path}`);
    return <Navigate to={path} replace={replace} state={state} />;
  }
  return null;
};

SafeRedirect.propTypes = {
  path: PropTypes.string,
  replace: PropTypes.bool,
  onCleanUp: PropTypes.func,
  navigateState: PropTypes.shape({}),
};

SafeRedirect.defaultProps = {
  path: '',
  replace: false,
  navigateState: {},
  onCleanUp: () => {},
};

export default SafeRedirect;
